import { isDoctor } from '@/data/service/authService';
import { useLocation } from 'react-router-dom';
import { SCHEDULED_CONSULT_PARAM } from '../Patient.constants';

export const useIsScheduledConsultActive = () => {
  const { search: searchParameters } = useLocation();
  const parsedParameters = new URLSearchParams(searchParameters);
  const consultParamValue = parsedParameters.get(SCHEDULED_CONSULT_PARAM);
  const isDoctorRole = isDoctor();

  if (!consultParamValue) {
    return false;
  }

  if (isNaN(Number(consultParamValue))) {
    return false;
  }

  if (!isDoctorRole) {
    return false;
  }

  return true;
};
